<template>
  <div class="plv-ia-lottery-confirm">
    <div v-show="!isShow" @click="showConfirm">
      <slot></slot>
    </div>
    <div v-show="isShow" class="plv-ia__lottery-confirm-group">
      <button class="plv-ia-lottery-btn--cancel" @click="cancelHandle">
        {{ t('plvIA.common.cancel') }}
      </button>
      <button class="plv-ia-lottery-btn--confirm" @click="confirmHandle">
        {{ t('plvIA.common.confirm') }}
      </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  name: 'LotteryConfirm',
  mixins: [Locale],
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    showConfirm() {
      this.isShow = true;
    },
    confirmHandle() {
      this.isShow = false;
      this.$emit('confirm');
    },
    cancelHandle() {
      this.isShow = false;
    }
  }
};
</script>

<style scoped lang="scss">
.plv-ia-lottery-confirm {
  width: 100%;
}
.plv-ia__lottery-confirm-group {
  text-align: right;
  button {
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    margin-left: 6px;
    background: white;
    cursor: pointer;
  }
  .plv-ia-lottery-btn--cancel {
    color: #666666 !important;
    border: 1px solid #EBEEF5;
  }
  .plv-ia-lottery-btn--confirm {
    border: 1px solid #2196F3;
    color: #2196F3;
  }
}

</style>
